import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../utils/utils';
import { declineTransaction } from '../../../../crud/sendRecive.crud';

type UseDeclineReturn = [
  (id: string) => Promise<void>,
  boolean,
  boolean
];

export const useDecline = (): UseDeclineReturn => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const fetchDecline = useCallback(async (id: string) => {
    setLoading(true);
    setSuccess(false);

    try {
      await declineTransaction(id);

      enqueueSnackbar('Successfully declined', {
        variant: 'success',
      });

      setSuccess(true);
    } catch (e) {
      enqueueSnackbar(
        `${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`,
        { variant: 'error' }
      );
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, intl]);

  return [fetchDecline, loading, success];
};
